// Local translations
export const T = {
  en_GB: {
    conditionalVisibility: "Conditional Visibility",
    conditionalVisibilityDescription: "Show this item only when a condition is met",
    whenField: "When field",
    selectField: "Select a field...",
    searchFields: "Search fields…",
    noFieldsAvailable: "No fields available.",
    noFieldsMatch: "No fields match your search.",
    selfSourceWarning:
      "This rule uses the component's own result as its source, which would hide the component permanently. Pick a different source field — saving will be rejected otherwise.",
    clientCountry: "Client Country",
    clientType: "Client Type",
    classificationType: "Classification Type",
    trapetsPep: "Trapets: PEP Status",
    trapetsSanctioned: "Trapets: Sanctioned Status",
    sumsubVerified: "Sumsub: Verified Status",
    sumsubDocumentCountry: "Sumsub: Document Country",
    followupMode: "Follow-up Mode",
    goalRiskScore: "Goal: Risk Score",
    portfolioType: "Portfolio: Portfolio Type",
    portfolioScheduleType: "Portfolio: Schedule Type",
    goalHasRisk: "Goal: Has Risk Assessment",
    goalRiskScoreCapped: "Goal: Risk Score Capped",
    goalType: "Goal: Type",
    clientField: "Client Field:",
    quizField: "Quiz:",
    flowField: "Flow Field:",
    goal: "[Goal]",
    condition: "Condition",
    isEmpty: "Is Empty",
    isNotEmpty: "Is Not Empty",
    contains: "Contains",
    notContains: "Does Not Contain",
    isOneOf: "Is One Of",
    isNotOneOf: "Is Not One Of",
    value: "Value",
    selectValue: "Select a value...",
    searchCountries: "Search countries…",
    noCountriesMatch: "No countries match your search.",
    enterValue: "Enter value...",
    person: "Person",
    company: "Company",
    group: "Group",
    modelPortfolio: "Model Portfolio",
    customPortfolio: "Custom Portfolio",
    dynamicPortfolio: "Dynamic Portfolio",
    oneTime: "One-time",
    recurring: "Recurring",
    yes: "Yes",
    no: "No",
    unchecked: "Unchecked",
    noRiskAssessment: "No risk assessment",
    capNotAssessed: "Cap could not be assessed",
  },
  nb_NO: {
    conditionalVisibility: "Betinget synlighet",
    conditionalVisibilityDescription: "Vis dette elementet kun når en betingelse er oppfylt",
    whenField: "Når felt",
    selectField: "Velg et felt...",
    searchFields: "Søk i felt…",
    noFieldsAvailable: "Ingen felt tilgjengelig.",
    noFieldsMatch: "Ingen felt samsvarer med søket.",
    selfSourceWarning:
      "Denne regelen bruker komponentens eget resultat som kilde, noe som ville skjult komponenten permanent. Velg et annet kildefelt — lagring avvises ellers.",
    clientCountry: "Kundeland",
    clientType: "Kundetype",
    classificationType: "Klassifikasjonstype",
    trapetsPep: "Trapets: PEP-status",
    trapetsSanctioned: "Trapets: Sanksjonsstatus",
    sumsubVerified: "Sumsub: Verifiseringsstatus",
    sumsubDocumentCountry: "Sumsub: Dokumentland",
    followupMode: "Oppfølgingsmodus",
    goalRiskScore: "Mål: Risikoscore",
    portfolioType: "Portefølje: Porteføljetype",
    portfolioScheduleType: "Portefølje: Plantype",
    goalHasRisk: "Mål: Har risikovurdering",
    goalRiskScoreCapped: "Mål: Risikoscore begrenset",
    goalType: "Mål: Måltype",
    clientField: "Kundefelt:",
    quizField: "Quiz:",
    flowField: "Flytfelt:",
    goal: "[Mål]",
    condition: "Betingelse",
    isEmpty: "Er tom",
    isNotEmpty: "Er ikke tom",
    contains: "Inneholder",
    notContains: "Inneholder ikke",
    isOneOf: "Er en av",
    isNotOneOf: "Er ikke en av",
    value: "Verdi",
    selectValue: "Velg en verdi...",
    searchCountries: "Søk i land…",
    noCountriesMatch: "Ingen land samsvarer med søket.",
    enterValue: "Skriv inn verdi...",
    person: "Person",
    company: "Selskap",
    group: "Gruppe",
    modelPortfolio: "Modellportefølje",
    customPortfolio: "Tilpasset portefølje",
    dynamicPortfolio: "Dynamisk portefølje",
    oneTime: "Engangs",
    recurring: "Gjentakende",
    yes: "Ja",
    no: "Nei",
    unchecked: "Ikke sjekket",
    noRiskAssessment: "Ingen risikovurdering",
    capNotAssessed: "Begrensningen kunne ikke vurderes",
  },
} as const;
